import { Box, IconButton, InputBase, Stack } from "@mui/material";
import React, { useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import { useDispatch } from "react-redux";
import { broadcastMessageAction } from "../../../store/action";

const SendMessage = ({onSendMessage}) => {

  const dispatch = useDispatch();
  const [message, setMessage] = useState(null);
  const handleSendMessage = () => {
    if (onSendMessage && message.trim()) {
      onSendMessage(message); // Dispatch the broadcast message action
      setMessage(''); // Clear the input after sending
  }
  };

 

  return (
    <Box>
      <Stack
        direction="row"
        backgroundColor="grey"
        justifyContent="space-between"
        alignItems="center"
        marginTop={2}
        borderRadius={1}
      >
        <InputBase
          placeholder="Send a message"
          variant="outlined"
          //   fullWidth
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSendMessage();
            }
          }}
          sx={{
            outline: "none",
            border: "none",
            padding: "5px",
          }}
        />
        <IconButton onClick={handleSendMessage}>
          <SendIcon />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default SendMessage;
